export default {
  drafted: 0,
  released: 1,
  timing: 2,
};
